import React, { Fragment } from "react";

import {
  AnswerFragment,
  QuestionFragment,
  QuestionTypeEnum,
} from "../../../../graphql/generated/definitions";

import AnswerEmpty from "./AnswerEmpty";
import AnswerTextReview from "./AnswerTextReview";
import AnswerSelectorSingleReview from "./AnswerSelectorSingleReview";
import AnswerSelectorMultipleReview from "./AnswerSelectorMultipleReview";

const is = (q: QuestionFragment, t: QuestionTypeEnum) => q.type === t;

type AnswerReviewDispatchProps = {
  answer: AnswerFragment;
  question: QuestionFragment;
  path: `sections.${number}.answers.${number}` | string;
};

const AnswerReviewDispatch: React.FC<AnswerReviewDispatchProps> = ({
  answer,
  question,
  path,
}) => {
  return (
    <Fragment>
      {answer.isEmpty && <AnswerEmpty {...{ answer, question, path }} />}
      {is(question, "QuestionText") && (
        <AnswerTextReview {...{ answer, question, path }} />
      )}
      {is(question, "QuestionSelectorSingle") && (
        <AnswerSelectorSingleReview {...{ answer, question, path }} />
      )}
      {is(question, "QuestionSelectorMultiple") && (
        <AnswerSelectorMultipleReview {...{ answer, question, path }} />
      )}
      {is(question, "QuestionEvaluation") && (
        <AnswerSelectorSingleReview {...{ answer, question, path }} />
      )}
      {is(question, "QuestionSkill") && (
        <AnswerSelectorSingleReview {...{ answer, question, path }} />
      )}
    </Fragment>
  );
};

export default AnswerReviewDispatch;
